<sales-error
  [contactHelpNumber]="'0800 597 8506'"
  [home]="'/'"
  [faq]="'/content/hoover-care-help-advice/hoover-faqs'"
  [contact]="'/content/contact-domestic-general'"
></sales-error>
